import { TYPES } from '../../common/constants';

export const startLoading = payload => ({
    type: TYPES.SET_LOADER_LOADING,
});

export const stopLoading = () => ({
    type: TYPES.STOP_LOADER_LOADING,
})

export const startPRLoading = () => ({
    type: TYPES.SET_PRLOADER_LOADING,
});

export const stopPRLoading = () => ({
    type: TYPES.STOP_PRLOADER_LOADING,
});

export const startFormLoading = () => ({
    type: TYPES.SET_FORMLOADER_LOADING,
});

export const stopFormLoading = () => ({
    type: TYPES.STOP_FORMLOADER_LOADING,
});

export const stopLoaders = () => dispatch => {
    dispatch(stopLoading());
    dispatch(stopPRLoading());
    dispatch(stopFormLoading());
}